(function () {
  'use strict';

  function getActiveVariantOptionFilters() {
    const params = new URLSearchParams(window.location.search);
    const filters = new Map();
    for (const [key, value] of params.entries()) {
      const match = key.match(/^filter\.v\.option\.(.+)$/i);
      if (match) {
        const optionName = match[1].toLowerCase();
        if (!filters.has(optionName)) filters.set(optionName, new Set());
        filters.get(optionName).add(value.toLowerCase().trim());
      }
    }
    return filters;
  }

  function fetchProductVariants(productHandle) {
    return fetch(`/products/${productHandle}.js`)
      .then((r) => (r.ok ? r.json() : { variants: [] }))
      .then((data) => data.variants || [])
      .catch(() => []);
  }

  function hasAvailableVariantForFilters(variants, filters) {
    if (filters.size === 0) return true;
    return variants.some((variant) => {
      if (!variant.available) return false;
      for (const [, allowedValues] of filters.entries()) {
        const allValues = [variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .map((o) => o.toLowerCase().trim());
        const hasMatch = [...allowedValues].some((v) => allValues.includes(v));
        if (!hasMatch) return false;
      }
      return true;
    });
  }

  async function filterOutOfStockProducts() {
    const activeFilters = getActiveVariantOptionFilters();
    if (activeFilters.size === 0) return;

    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const items = Array.from(productGrid.querySelectorAll('li.grid__item'));
    if (!items.length) return;

    await Promise.all(
      items.map(async (item) => {
        const link = item.querySelector('a[href*="/products/"]');
        if (!link) return;
        const m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
        if (!m) return;
        const variants = await fetchProductVariants(m[1]);
        if (!hasAvailableVariantForFilters(variants, activeFilters)) {
          item.style.display = 'none';
          item.setAttribute('data-oos-hidden', 'true');
        }
      })
    );

    updateEmptyState(productGrid);
  }

  function updateEmptyState(productGrid) {
    const visible = Array.from(productGrid.querySelectorAll('li.grid__item'))
      .filter((el) => el.style.display !== 'none');
    const container = document.querySelector('#ProductGridContainer .collection');
    if (!container) return;
    const existing = container.querySelector('.oos-empty-message');
    if (visible.length === 0) {
      if (!existing) {
        const msg = document.createElement('div');
        msg.className = 'oos-empty-message title-wrapper center';
        msg.style.padding = '40px 0';
        msg.innerHTML =
          '<h2 class="title title--primary" style="font-size:1.4rem">Niciun produs disponibil în stoc pentru mărimea selectată.</h2>';
        container.appendChild(msg);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function resetHiddenItems() {
    document.querySelectorAll('[data-oos-hidden="true"]').forEach((el) => {
      el.style.display = '';
      el.removeAttribute('data-oos-hidden');
    });
    document.querySelectorAll('.oos-empty-message').forEach((m) => m.remove());
  }

  function observeProductGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(() => {
      resetHiddenItems();
      filterOutOfStockProducts();
    }).observe(container, { childList: true, subtree: false });
  }

  function init() {
    filterOutOfStockProducts();
    observeProductGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
